module.exports = __webpack_public_path__ + "media/images/font_plus-ea255813b87443143fec22eeb81b22cb.svg";